import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeRectangleRoundedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.48 15.58C20.48 17.3 19.24 18.54 17.52 18.54H6.48C4.76 18.54 3.52 17.3 3.52 15.58V8.34C3.52 6.62 4.76 5.38 6.48 5.38H17.52C19.24 5.38 20.48 6.62 20.48 8.34V15.58ZM18.64 15.58V8.34C18.64 7.7 18.16 7.22 17.52 7.22H6.48C5.84 7.22 5.36 7.7 5.36 8.34V15.58C5.36 16.22 5.84 16.7 6.48 16.7H17.52C18.16 16.7 18.64 16.22 18.64 15.58Z" />
    </SvgIcon>
  );
});
